import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import colors from '../utils/colors';

const shown = (active, all) => (!active || active.length >= all.length ? all.length : active.length);

/** Compact button label: "All" when nothing is filtered, otherwise "(n)" = services + roles still shown */
export const filterSummary = (services, roles, activeServices, activeRoles) => {
	const filtered = shown(activeServices, services) < services.length || shown(activeRoles, roles) < roles.length;
	return filtered ? `(${shown(activeServices, services) + shown(activeRoles, roles)})` : 'All';
};

/** Tooltip with the full picture: "2 of 3 services · 3 of 3 roles shown" */
export const filterTitle = (services, roles, activeServices, activeRoles) =>
	`${shown(activeServices, services)} of ${services.length} services · ${shown(activeRoles, roles)} of ${roles.length} roles shown`;

/**
 * One compact dropdown to choose which services (rows) and roles (columns) are shown.
 * `activeX` null = all. At least one of each always stays checked.
 * onChange(kind, ids) with kind 'services' | 'roles'.
 */
export default function ServicesFilterDropdown({ services, roles, activeServices, activeRoles, onChange, disabled }) {
	const section = (kind, title, items, active) => {
		const selected = active ?? items.map(i => i.id);
		const allSelected = selected.length >= items.length;
		return [
			<Dropdown.Header key={`${kind}_header`} style={{ display: 'flex', alignItems: 'center' }}>
				<span style={{ flex: 1 }}>{title}</span>
				{!allSelected &&
					<a href='#all' style={{ textTransform: 'none', fontWeight: 'normal' }}
						onClick={(e) => { e.preventDefault(); onChange(kind, items.map(i => i.id)); }}>All</a>
				}
			</Dropdown.Header>,
			...items.map(item => {
				const checked = selected.includes(item.id);
				const last = checked && selected.length === 1;
				return (
					<Dropdown.Item
						key={`${kind}_${item.id}`}
						disabled={last}
						title={last ? `At least one ${kind === 'services' ? 'service' : 'role'} stays shown` : undefined}
						onClick={() => onChange(kind, checked ? selected.filter(id => id !== item.id) : [...selected, item.id])}
					>
						<Icon name={checked ? 'check square' : 'square outline'} style={{ color: checked ? colors.primary : colors.midGray }} />
						{item.name}
					</Dropdown.Item>
				);
			}),
		];
	};

	return (
		<Dropdown
			className='svc-filter'
			button basic floating
			disabled={disabled}
			trigger={<span title={filterTitle(services, roles, activeServices, activeRoles)}><Icon name='filter' />{filterSummary(services, roles, activeServices, activeRoles)}</span>}
		>
			{/* clicks inside the menu must not toggle (close) the dropdown, so several boxes can be checked in a row */}
			<Dropdown.Menu onClick={(e) => e.stopPropagation()}>
				{section('services', 'Services', services, activeServices)}
				<Dropdown.Divider />
				{section('roles', 'Roles', roles, activeRoles)}
			</Dropdown.Menu>
		</Dropdown>
	);
}
